import React from 'react';
import { FileText, Clock, Shield, AlertCircle } from 'lucide-react';

export function AuditView() {
  return (
    <div className="h-full flex flex-col overflow-hidden bg-slate-50">
      {/* Header */}
      <div className="flex-shrink-0 bg-white border-b border-slate-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center">
              <FileText className="h-5 w-5 text-purple-600" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-slate-900">Audit Trail</h2>
              <p className="text-sm text-slate-500">Activity logs and security events</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl border border-slate-200 p-12 text-center shadow-sm">
            <div className="w-16 h-16 rounded-2xl bg-purple-50 flex items-center justify-center mx-auto mb-4">
              <FileText className="h-8 w-8 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Audit Trail Coming Soon</h3>
            <p className="text-sm text-slate-500 mb-8 max-w-sm mx-auto">
              Track user activities, security events, and changes across your customer accounts.
            </p>
            
            <div className="grid grid-cols-3 gap-4">
              <div className="p-4 bg-slate-50 rounded-xl">
                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center mx-auto mb-3">
                  <Clock className="h-5 w-5 text-blue-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Activity Logs</div>
                <div className="text-xs text-slate-500 mt-1">Track all user actions</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-xl">
                <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center mx-auto mb-3">
                  <Shield className="h-5 w-5 text-emerald-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Security Events</div>
                <div className="text-xs text-slate-500 mt-1">Login & access logs</div>
              </div>
              <div className="p-4 bg-slate-50 rounded-xl">
                <div className="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center mx-auto mb-3">
                  <AlertCircle className="h-5 w-5 text-orange-600" />
                </div>
                <div className="text-sm font-medium text-slate-900">Alerts</div>
                <div className="text-xs text-slate-500 mt-1">Anomaly detection</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 